/**
 * File: categories_context.tsx
 * Description: Defines the React context and custom hook for sharing FAQ categories state across the public interface.
 */

import { createContext, useContext } from "react";
import type { CategoriesState } from "@/interfaces/category";

export const CategoriesContext = createContext<CategoriesState | undefined>(undefined);

/**
 * Custom hook that returns the CategoriesContext value.
 * Must be called inside a component wrapped by CategoriesProvider.
 *
 * @returns {CategoriesState} The current categories state and its updater.
 * @throws {Error} When called outside of a CategoriesProvider tree.
 */
export const useCategoriesContext = () => {
  const context = useContext(CategoriesContext);
  if (context === undefined) {
    throw new Error("CategoriesContext must be used inside CategoriesProvider");
  }
  return context;
};
